module.exports = __webpack_public_path__ + "static/media/ly.7dd318a3.png";